import { render, staticRenderFns } from "./CardElement.vue?vue&type=template&id=a3447368&scoped=true&"
import script from "./CardElement.vue?vue&type=script&lang=js&"
export * from "./CardElement.vue?vue&type=script&lang=js&"
import style0 from "./CardElement.vue?vue&type=style&index=0&id=a3447368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3447368",
  null
  
)

export default component.exports